import { createSlice } from "@reduxjs/toolkit";
import {
  createCampaign,
  deleteCampaignByIdData,
  editCampaignByIdData,
  fetchCampaignByIdData,
  fetchCampaignsData,
  fetchMediaPlanData,
  fetchInitialRecommendation,
} from "../thunks/campaignsThunk.tsx";
import {
  CampaignByIdItemDataType,
  CampaignsDataType,
  CampaignsInfoDataType,
  RecommendationsItemDataType,
  MediaPlanDataType,
} from "../types/campaignsTypes.tsx";

interface State {
  isLoading: boolean;
  isLoadingById: boolean;
  isLoadingCreate: boolean;
  isLoadingDelete: boolean;
  isLoadingByIdEdit: boolean;
  isLoadingMediaPlan: boolean;
  campaigns: CampaignsDataType | null;
  mediaPlanData: MediaPlanDataType | null;
  campaignsInfoData: CampaignsInfoDataType | null;
  campaignById: CampaignByIdItemDataType | null;
  initRecommendation: RecommendationsItemDataType[] | null;
}

const initialState: State = {
  isLoading: false,
  isLoadingMediaPlan: false,
  isLoadingById: false,
  isLoadingCreate: false,
  isLoadingDelete: false,
  isLoadingByIdEdit: false,
  campaigns: null,
  mediaPlanData: null,
  campaignsInfoData: null,
  campaignById: null,
  initRecommendation: null,
};
export const campaignsSlice = createSlice({
  name: "campaigns",
  initialState,
  reducers: {
    setCampaignsInfo: (state, action) => {
      state.campaignsInfoData = action.payload;
    },
    clearCampaigns: (state) => {
      state.campaigns = initialState.campaigns;
    },
    clearCampaignById: (state) => {
      state.campaignById = initialState.campaignById;
    },
    clearMediaPlan: (state) => {
      state.mediaPlanData = initialState.mediaPlanData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCampaignsData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCampaignsData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.campaigns = action.payload;
    });
    builder.addCase(fetchCampaignsData.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(fetchMediaPlanData.pending, (state) => {
      state.isLoadingMediaPlan = true;
    });
    builder.addCase(fetchMediaPlanData.fulfilled, (state, action) => {
      state.isLoadingMediaPlan = false;
      state.mediaPlanData = action.payload;
    });
    builder.addCase(fetchMediaPlanData.rejected, (state) => {
      state.isLoadingMediaPlan = false;
    });
    builder.addCase(fetchCampaignByIdData.pending, (state) => {
      state.isLoadingById = true;
    });
    builder.addCase(fetchCampaignByIdData.fulfilled, (state, action) => {
      state.isLoadingById = false;
      state.campaignById = action.payload;
    });
    builder.addCase(fetchCampaignByIdData.rejected, (state) => {
      state.isLoadingById = false;
      state.campaignById = null;
    });
    builder.addCase(createCampaign.pending, (state) => {
      state.isLoadingCreate = true;
    });
    builder.addCase(createCampaign.fulfilled, (state) => {
      state.isLoadingCreate = false;
    });
    builder.addCase(createCampaign.rejected, (state) => {
      state.isLoadingCreate = false;
    });
    builder.addCase(editCampaignByIdData.pending, (state) => {
      state.isLoadingByIdEdit = true;
    });
    builder.addCase(editCampaignByIdData.fulfilled, (state, action) => {
      state.isLoadingByIdEdit = false;
      state.campaignById = {
        ...state.campaignById,
        ...action.payload,
        total_budget: action.payload.budget,
        time_frame: {
          start: action.payload.start_date,
          end: action.payload.end_date,
        },
      };
    });
    builder.addCase(editCampaignByIdData.rejected, (state) => {
      state.isLoadingByIdEdit = false;
    });
    builder.addCase(deleteCampaignByIdData.pending, (state) => {
      state.isLoadingDelete = true;
    });
    builder.addCase(deleteCampaignByIdData.fulfilled, (state, action) => {
      state.isLoadingDelete = false;
      if (state.campaigns) {
        state.campaigns = state.campaigns.filter(
          (item) => item.id.toString() !== action.payload.toString(),
        );
      }
    });
    builder.addCase(deleteCampaignByIdData.rejected, (state) => {
      state.isLoadingDelete = false;
    });
    builder.addCase(fetchInitialRecommendation.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchInitialRecommendation.fulfilled, (state, action) => {
      state.isLoading = false;
      state.initRecommendation = action.payload;
    });
    builder.addCase(fetchInitialRecommendation.rejected, (state) => {
      state.isLoading = false;
    });
  },
});
export const {
  setCampaignsInfo,
  clearCampaignById,
  clearMediaPlan,
  clearCampaigns,
} = campaignsSlice.actions;
